const GTM_ID = String(process.env.REACT_APP_GTM_ID || '').trim();

function sanitizeParams(params = {}) {
  return Object.entries(params).reduce((accumulator, [key, value]) => {
    if (value === undefined || value === null || value === '') return accumulator;
    accumulator[key] = value;
    return accumulator;
  }, {});
}

export function trackEvent(name, params = {}) {
  if (typeof window === 'undefined' || !name) return;
  if (!GTM_ID && !Array.isArray(window.dataLayer)) return;

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: String(name),
    ...sanitizeParams(params),
  });
}
